// docs/145 KH6: heroes on the board are their kit looks. Each baked look is a texture `hk:<look key>` (frame A; the
// board stands still, as the Oryx frames did), added to a scene as looks bake; `unitFrame` hands it to every hero
// unit (not a ranger's beast) in place of its Oryx frame, so the figure, its outline, its fall, its ghost and its
// body all come from one place.
import type Phaser from 'phaser';
import { allBaked, bakeHero, classLook, KIT_ORIGIN, lookKey, onBaked, type HeroLook } from '../heroKit';
import { heroLookNow } from '../../core/heroes/looks';
import { isCompanionId } from '../../core/sim/companion';

export const KIT_PREFIX = 'hk:';
export const isKitKey = (key: string): boolean => key.startsWith(KIT_PREFIX);
/** The kit canvas's feet row as an image origin (x is the middle, 0.5). */
export const KIT_ORIGIN_Y = KIT_ORIGIN.y;

/** A hero unit's look: its own from the store, else its class's plain kit (a gallery's stand-in). */
export function unitLook(unit: { heroId?: number; faction?: string; classId?: string }): HeroLook | undefined {
  if (unit.heroId === undefined || unit.faction !== 'hero' || isCompanionId(unit.heroId)) return undefined;
  return heroLookNow(unit.heroId) ?? classLook(unit.classId);
}

/** The texture key a hero unit is drawn with (whether or not it is in a scene yet). */
export function kitKeyOf(unit: { heroId?: number; faction?: string; classId?: string }): string | undefined {
  const look = unitLook(unit);
  if (!look) return undefined;
  void bakeHero(look);
  return KIT_PREFIX + lookKey(look);
}

/** Adds every baked look to `scene` as a texture, now and as more bake; `changed` hears of each new one. */
export function registerKitTextures(scene: Phaser.Scene, changed?: () => void): () => void {
  const add = (): boolean => {
    let any = false;
    for (const f of allBaked()) {
      const key = KIT_PREFIX + f.key;
      if (scene.textures.exists(key)) continue;
      const t = scene.textures.addCanvas(key, f.a);
      t?.setFilter(1 /* Phaser.Textures.FilterMode.NEAREST (LINEAR is 0) */);
      any = true;
    }
    return any;
  };
  add();
  return onBaked(() => { if (add()) changed?.(); });
}
